import { render } from "./linkComponent.vue?vue&type=template&id=7981ff34"
import script from "./linkComponent.vue?vue&type=script&lang=js"
export * from "./linkComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ProjetosCodes\\Ideias\\front\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__